export const getAccessTokenValidity = (token) => {
    if (!token) {
        return 0;
    }
    return Math.round(Math.max(0, token.issuedAt + token.accessTokenExpiresIn - Date.now() / 1000));
};
export const getRefreshTokenValidity = (token) => {
    if (!token) {
        return 0;
    }
    return Math.round(Math.max(0, token.issuedAt + token.refreshTokenExpiresIn - Date.now() / 1000));
};
//# sourceMappingURL=datev.js.map